import { Routes, Route, Navigate } from 'react-router-dom';
import { useSelector } from 'react-redux';

import { ForgotPassword, Login, Register, ResetPassword } from './';

export { AccountLayout };

function AccountLayout() {
    const auth = useSelector(x => x.auth.value);

    // redirect to home if already logged in
    if (auth) {
        return <Navigate to="/" />;
    }

    return (
        <div className="login-page-body relative">
            <Routes>
                <Route path="login" element={<Login />} />
                <Route path="register" element={<Register />} />
                <Route path="forgot-password" element={<ForgotPassword />} />
                <Route path="reset-password" element={<ResetPassword />} />
            </Routes>
        </div>
    );
}
